import { render } from "./PlaceholderSettings.vue?vue&type=template&id=0c0c7b90&scoped=true"
import script from "./PlaceholderSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PlaceholderSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./PlaceholderSettings.vue?vue&type=style&index=0&id=0c0c7b90&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0c7b90"]])

export default __exports__